module.exports = __webpack_public_path__ + "img/close-popup-black.31f52863.svg";